export default __webpack_public_path__ + "static/media/logo-isoft.b93b88b6.png";